import styles from './block-order.module.scss'
import React, { useState, useEffect, useRef } from 'react'

import { compare } from 'utils'

//antd
import { Input, Row, Col, Table, Button, Popconfirm, notification, Select } from 'antd'

//icons
import { DeleteOutlined, PlusCircleOutlined } from '@ant-design/icons'

//components
import BlockOrderForm from './block-order-form'

//apis
import { deleteBranch, getBranches } from 'apis/branch'
import { getLockOrderSettings, updateLockOrderSettings, deleteLockOrderSettings } from 'apis/lock-order-settings'

import { getCountries } from 'apis/country'
import { getRegions } from 'apis/region'

const HOST_LINK_COMMENT = 'https://elgaucho.asia'
export default function Branch() {
  // const typingTimeoutRef = useRef(null)
  // const { Option } = Select

  const [loading, setLoading] = useState(false)
  const [branchs, setBranchs] = useState([])
  // const [countries, setCountries] = useState([])
  const [regions, setRegions] = useState([])
  const [allRegion, setAllRegion] = useState([])
  const [blockOrderSettings, setblockOrderSettings] = useState([])
  const [countLocation, setCountLocation] = useState(0)
  const [paramsFilter, setParamsFilter] = useState({ page: 1, page_size: 20 })


  const _getBlockOrderSettings = async () => {
    try {
      const res = await getLockOrderSettings()
      if (res.status === 200) setblockOrderSettings(res.data.data)
    } catch (e) {
      console.log(e)
    }
  }

  const _getAllRegion = async () => {
    try {
      const res = await getRegions()
      if (res.status === 200) setAllRegion(res.data.data)
    } catch (e) {
      console.log(e)
    }
  }

  const _getBranches = async () => {
    try {
      setLoading(true)
      const res = await getBranches({ ...paramsFilter })
      if (res.status === 200) {
        setBranchs(res.data.data)
        setCountLocation(res.data.count)
      }
      setLoading(false)
    } catch (error) {
      setLoading(false)
    }
  }

  const _getRegions = async (query) => {
    try {
      const res = await getRegions(query)
      if (res.status === 200) setRegions(res.data.data)
    } catch (error) {
      console.log(error)
    }
  }

  const _deleteBlockOrderSettings =async (date) => {
    try {
      const res = await deleteLockOrderSettings({date: date})
      if (res.status === 200) window.location.reload();
    } catch (error) {
      console.log(error)
    }
  }

  
  
  const columns = [
    {
      title: 'STT',
      render: (text, record, index) => (paramsFilter.page - 1) * paramsFilter.page_size + index + 1,
      //render: (text, record, index) =>(<></>)
    },
    {
      title: 'Date',
      dataIndex: 'date',
      // render: (text, record, index) => (paramsFilter.page - 1) * paramsFilter.page_size + index + 1,
      render: (text, record, index) =>(<div>{text}</div>),
     
    },
    {
      title: 'Pickup',
      render: (text, record) => (<div style={{maxWidth: '300px'}}>{record.pickups.map((pickup) => {

        // (<div>
        //   {{branchs.find((branch) => branch.branch_id == pickup.branch_id)?.name + ":" + pickup.times.join(",")}}
        // <div/>);
          let text = branchs.find((branch) => branch.branch_id == pickup.branch_id)?.name + ":" + pickup.times.join(",");
         return <>{text}<br/></>
        }
      )}</div> ),
    },
    {
      title: 'Delivery',
      render: (text, record) => (
      <div style={{maxWidth: '300px'}}>{record.deliveries.map((delivery) => {
        let text = regions.find((region) => region.region_id == delivery.region_id)?.name  + ":" + delivery.times.join(",") ;
        return <>{text}<br/></>
      })}</div>),
    },
    {
      title: 'Hành động',
      render: (text, record) => (
        <Popconfirm
          onConfirm={() => {
            _deleteBlockOrderSettings(record.date)

          }}// _deleteBranch(record.branch_id)}
          title="Bạn có muốn xóa dữ liệu này không?"
        >
          <Button icon={<DeleteOutlined />} type="primary" danger  />
        </Popconfirm>
      ),
    },
  ]

  // const _clearFilters = () => {
  //   setParamsFilter({ page: 1, page_size: 20 })
  //   setValueSearch('')
  // }

  // useEffect(() => {
  //   _getBranches()
  // }, [paramsFilter])

  useEffect(() => {
    _getRegions();
    _getAllRegion()
    _getBranches();
    _getBlockOrderSettings()
  }, [])

  return (
    <div className={`${styles['promotion_manager']} ${styles['card']}`}>
      <Row
        wrap={false}
        align="middle"
        justify="space-between"
        style={{ borderBottom: '1px solid rgb(236, 226, 226)', paddingBottom: '0.75rem',width: '100%' }}
      >
        <div style={{ fontWeight: '600', fontSize: '1.2rem' }}>Quản lý block Order</div>
        <BlockOrderForm regions={allRegion} reloadData={_getBranches}>
          <Button size="large" icon={<PlusCircleOutlined />} type="primary">
            Thêm giờ block
          </Button>
        </BlockOrderForm>
      </Row>

      <Table
        size="small"
        rowKey="_id"
        loading={loading}
        columns={columns}
        dataSource={blockOrderSettings}
        style={{ width: '100%', marginTop: 20 }}
        pagination={{
          position: ['bottomLeft'],
          current: paramsFilter.page,
          pageSize: paramsFilter.page_size,
          pageSizeOptions: [20, 30, 40, 50, 70, 100],
          showQuickJumper: true,
          onChange: (page, pageSize) =>
            setParamsFilter({ ...paramsFilter, page: page, page_size: pageSize }),
          total: countLocation,
        }}
      />
      
    </div>
  )
}
